import { ReactElement } from 'react'
import { useNavigate } from 'react-router'

import CreditBalanceRefund from 'cbr-mfe'
import getMFEConfig from 'helpers/getMFEConfig'
import routes from 'const/routes'
import { handleMFEAuthenticationRedirect } from 'helpers/authenticationRedirect'
import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'
import useNavigateOnRedirect from 'hooks/useNavigateOnRedirect'
import styled from 'styled-components'
import Inset from 'syf-component-library/ui/spacing/Inset/Inset'
import useProfileNavigate from 'hooks/useProfileNavigate'
import { useAtomValue } from 'jotai'
import { selectedAccountAtom } from 'store/atoms'

const CreditBalanceRefundWrapper = styled(Inset)`
  max-width: 1200px;
  margin: auto;
`

const CreditBalanceRefundPage = (): ReactElement => {
  const navigate = useNavigate()
  const { handleProfileClick } = useProfileNavigate()

  const selectedAccount = useAtomValue(selectedAccountAtom)

  const mfeConfig = getMFEConfig('mfe')

  const handleBackToDashboard = () => {
    navigate(routes.HOME)
  }

  useNavigateOnRedirect()

  return (
    <CreditBalanceRefundWrapper>
      <CreditBalanceRefund
        config={mfeConfig}
        accountId={selectedAccount}
        backToAccountManagerHandler={handleBackToDashboard}
        triggerAnalyticsEvent={triggerAnalyticsEvent}
        handleProfileClick={handleProfileClick}
        authenticationRedirect={handleMFEAuthenticationRedirect}
      />
    </CreditBalanceRefundWrapper>
  )
}

export default CreditBalanceRefundPage
